






































import { Logger } from '@/Shared/Logger';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import VatsAPI from '@/Shared/VatsAPI';
import VatsGoogleMap from '@/Shared/VatsGoogleMaps/VatsGoogleMap.vue';
import Multiselect from 'vue-multiselect';
import mixins from 'vue-typed-mixins';
import { mapGetters } from 'vuex';
import GoogleMapsPolygon from './GoogleMapsPolygon';
import LotLkup from './LotLkup';

const LotAreaAdmin = mixins(LocationBasedMixin).extend({
    components: {
        VatsGoogleMap,
        Multiselect
    },
    data() {
        return {
            mapConfig: {} as google.maps.MapOptions,
            initialGeography: {} as google.maps.PolygonOptions,
            lots: [] as LotLkup[],
            selectedLot: {} as LotLkup,
            unsavedChanges: false
        };
    },
    computed: {
        canSave(): boolean {
            return this.unsavedChanges;
        },
        ...mapGetters('loaderModule', ['loading'])
    },
    async mounted() {
        await this.init();
    },
    methods: {
        locationChanged() {
            this.init();
        },
        async init() {
            this.selectedLot = {} as LotLkup;
            this.unsavedChanges = false;

            const latLongString = (
                await VatsAPI
                    .get<string>(`/${this.location}/lotmaintenance/GetLatLongForLocation`)
            ).data;

            const latLongArr = latLongString.split(',');
            const latLongObj: google.maps.LatLngLiteral = {
                lat: parseFloat(latLongArr[0]),
                lng: parseFloat(latLongArr[1])
            };

            const lots = (await VatsAPI.get<LotLkup[]>(`/${this.location}/lotmaintenance/GetLotsForLocation`)).data;
            this.lots = lots;

            this.mapConfig = {
                zoom: 14,
                mapTypeId: 'roadmap',
                center: latLongObj
            };
        },
        polygonChanged(polygon: google.maps.Polygon) {
            if (polygon) {
                this.selectedLot.geographicalLocation.path = polygon.getPath()
                    .getArray()
                    .map(latlng => {
                        return {
                            lat: latlng.lat(),
                            lng: latlng.lng()
                        };
                    });

                this.unsavedChanges = true;
            }
        },
        lotSelected(lot: LotLkup, recID: number) {
            let opts = { editable: true } as google.maps.PolygonOptions;
            let geographicalLocation = {} as GoogleMapsPolygon;
            this.selectedLot = lot;

            if (lot.geographicalLocation && lot.geographicalLocation.path && lot.geographicalLocation.path.length) {
                geographicalLocation = lot.geographicalLocation;
                opts.paths = geographicalLocation.path;
            }
            else {
                this.selectedLot.geographicalLocation = geographicalLocation;
            }

            opts = { ...geographicalLocation, ...opts };
            this.initialGeography = opts;
        },
        clearPolygon() {
            this.initialGeography = {};
        },
        async save() {
            await VatsAPI.post(`/${this.location}/lotmaintenance/UpdateLotArea`, { ...this.selectedLot });
            this.unsavedChanges = false;
        }
    }
});

export default LotAreaAdmin;
